<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="tail-of-the-gilded-age-1914" style="padding-top:150px;">
<h1>Tail of the Gilded Age, 1914</h1>
<p style="text-align: center;">All good things come to an end, in order to give birth to new beginnings…</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?5ae6121a